/**
 * 第三方渠道对应intl方的渠道id
 */
export enum THRID_CHANNLE {
  FACEBOOK = 4,
  GOOGLE = 6,
  TWITTER = 9,
  APPLE = 15,
  VK = 19,
  DISCORD = 26,
  EMAIL = 131,
}

export enum LOGIN_ERROR {
  NO_GAME_ACCOUNT = 1, // 没有游戏账号
  LOGIN_ERROR = 2, // 三方登录失败
  CAMP_LOGIN_ERROR = 3, // 营地登陆失败
  SEND_VERIFY_CODE_ERROR = 4, // 发送验证码失败
  GAMG_LOGIN_ERROR = 5, // 游戏登录失败
  IP_ERROR = 6, // ip被ban
}
export const LOGIN_ERROR_MESSAGE = {
  [LOGIN_ERROR.NO_GAME_ACCOUNT]: 'sign_in_fail',
  [LOGIN_ERROR.LOGIN_ERROR]: 'sign_in_fail',
  [LOGIN_ERROR.CAMP_LOGIN_ERROR]: 'sign_in_fail',
  [LOGIN_ERROR.SEND_VERIFY_CODE_ERROR]: 'correct_email',
  [LOGIN_ERROR.GAMG_LOGIN_ERROR]: 'game_sign_in_error',
  [LOGIN_ERROR.IP_ERROR]: 'game_ip_error',
};

export const THRID_CHANNLE_NAME = {
  [THRID_CHANNLE.DISCORD]: 'discord',
  [THRID_CHANNLE.FACEBOOK]: 'facebook',
  [THRID_CHANNLE.GOOGLE]: 'google',
  [THRID_CHANNLE.APPLE]: 'apple',
  [THRID_CHANNLE.VK]: 'vk',
  [THRID_CHANNLE.TWITTER]: 'twitter',
};
